import { Injectable } from '@angular/core';

import { Application } from '@core/models/application';
import { CoreHttpService } from './core-http.service';
import { firstValueFrom } from 'rxjs';
import { SerieItem } from '@core/models/serie-item';
import { Video } from '@core/models/video';

@Injectable({
	providedIn: 'root'
})
export class ApplicationService {

	public application: Application;
	public paywallSliderItems: SerieItem[] | Video[];

	constructor(private coreHttpService: CoreHttpService) {

		this.application = new Application();
	}

	async getApplicationData(): Promise<Application> {

		return new Promise<Application>(async (resolve, reject) => {

			const application = await firstValueFrom(this.coreHttpService.getApplicationData());
			this.application = application;

			this.paywallSliderItems = application.paywallSlider

			resolve(application);
		});
	}
}